import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataBank(params) {
	return client.get("api/ecommerce/bank/data", {
		params: params,
	});
}

function exportBank(params) {
	return client.get("api/ecommerce/bank/export", {
		params: params,
	});
}

function addBank(params) {
	return client.post("api/ecommerce/bank/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateBank(params) {
	return client.post("api/ecommerce/bank/update", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteBank(params) {
	return client.post("api/ecommerce/bank/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getDataBankAccount(params) {
	return client.get("api/ecommerce/bank-account/data", {
		params: params,
	});
}

function exportBankAccount(params) {
	return client.get("api/ecommerce/bank-account/export", {
		params: params,
	});
}

function addBankAccount(params) {
	return client.post("api/ecommerce/bank-account/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateBankAccount(params) {
	return client.post("api/ecommerce/bank-account/update", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteBankAccount(params) {
	return client.post("api/ecommerce/bank-account/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDataBank,
	exportBank,
	addBank,
	updateBank,
	deleteBank,
	getDataBankAccount,
	exportBankAccount,
	addBankAccount,
	updateBankAccount,
	deleteBankAccount,
}